export function slugify(text: string) {
  return text
    .toLowerCase()
    .replace(/é|è|ê/g, "e")
    .replace(/à/g, "a")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}
